import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router";
import "./SourceDataGrid.css";
import ValidationPopup from "../SendValidationPopup/SendValidationPopup";
import { queueRecordForValidation } from "../../Pages/IndividualSearchPage/individualSearchSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";

const SourceDataGrid = ({ rows }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const columns = [
    { field: "inD_ID_CEGEDIM", headerName: "OneKey ID", width: 150 },
    { field: "ahprA_ID", headerName: "AHPRA ID", width: 150 },
    {
      field: "view",
      headerName: "View",
      renderCell: (params) => (
        <VisibilityIcon
          onClick={() => handleView(params.row)}
          style={{ cursor: "pointer", color: "#2e3b55" }}
        />
      ),
      sortable: false,
      width: 70,
    },
    {
      field: "aprhA_VALIDATION_STATUS",
      headerName: "Validation Status",
      width: 180,
    },
    { field: "firstname", headerName: "First Name", width: 150 },
    { field: "middlename", headerName: "Middle Name", width: 150 },
    { field: "lastname", headerName: "Last Name", width: 150 },
    // { field: "administrativE_NAME", headerName: "Administrative Name", width: 180 },
    // { field: "nickname", headerName: "Nickname", width: 150 },
    { field: "inD_TYPE_lbl", headerName: "Type", width: 130 },
    { field: "specialtY_1_lbl", headerName: "Specialty 1", width: 150 },
    { field: "specialtY_2_lbl", headerName: "Specialty 2", width: 150 },
    // { field: "specialtY_3_lbl", headerName: "Specialty 3", width: 150 },
    { field: "hcP_State", headerName: "State", width: 100 },
    { field: "hcP_City", headerName: "City", width: 150 },
    { field: "hcP_PostCode", headerName: "Post Code", width: 120 },
    {
      field: "date_last_AHPRA_validation",
      headerName: "Last AHPRA Validation Date",
      width: 180,
      renderCell: (params) =>
        params.value
          ? new Intl.DateTimeFormat("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }).format(new Date(params.value))
          : "",
    },
    // { field: "ok_user", headerName: "OK User", width: 150 },
    // { field: "oK_Comment", headerName: "OK Comment", width: 200 },
    {
      field: "aprhA_LAST_VALIDATION_DATE",
      headerName: "Last Validation Date",
      width: 180,
      renderCell: (params) =>
        params.value
          ? new Intl.DateTimeFormat("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }).format(new Date(params.value))
          : "",
    },
  ];

  const handleView = (record) => {
    setSelectedRecord(record);
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setSelectedRecord(null);
  };

  const handleSendForValidation = (validatedRecord, userEmail) => {
    console.log("Sending for validation:", validatedRecord);
    console.log("Send by user: " + userEmail);
    dispatch(
      queueRecordForValidation({
        record: validatedRecord,
        useremail: userEmail,
      })
    );
  };

  return (
    <div className="data-grid-container">
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
        disableSelectionOnClick
        disableRowSelectionOnClick
        getRowId={(row) => row.inD_ID_CEGEDIM || row.id}
        sx={{
          border: "2px solid #2e3b55",
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#f5f5f5",
            color: "#2e3b55",
            fontSize: "16px",
            fontWeight: "bolder",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold",
          },
          "& .MuiDataGrid-root": {
            height: "100%",
          },
          "& .MuiDataGrid-cell": {
            fontSize: "14px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
          overflowX: "auto",
        }}
        initialState={{
          density: "compact",
          pagination: {
            paginationModel: {
              pageSize: 25,
            },
          },
        }}
      />
      {selectedRecord && (
        <ValidationPopup
          open={isPopupOpen}
          onClose={handleClosePopup}
          record={selectedRecord}
          onSend={handleSendForValidation}
        />
      )}
    </div>
  );
};

export default SourceDataGrid;
